import EnterManage from './enterManage.vue'

export default [{
    path: '/enterManage',
    name:'enterManage',
    component:EnterManage
}]